<script>
	import{ onMount } from 'svelte';
	import Portal from 'svelte-portal';
	import { quantity, method, postal, shipping } from './store.js'
	import { getCookie } from './utilities'
	import en from "../strings.en"
	import fr from "../strings.fr"

	export let buyability, buyabilityFlags, lang='en', productCode, ehf, maxQty, llQty, productName, productBrand, productCategory, price, loyaltyEligible, useLoyaltyService, displayLoyaltyToEndUser, isProBrand, isProductOfCanada, isMadeInCanada, availability, productCategoryCrumbs;

	const preferredStore = localStorage.preferredStore ? JSON.parse(localStorage.getItem('preferredStore'))|| false : false;

	let openWishlistModal = false;
	let itemPriceForLoyalty = 0;

	let strings = lang == 'en' ? en : fr;
	let _strings = strings.strings
    let userLoyaltyEnabled = false;
    let showLoyaltyService = false;
    let storeSceneEnabled = false;
	let preferredStoreProvince = localStorage.getItem('preferredStore') ? JSON.parse(localStorage.preferredStore).address.stateOrProvince.toLowerCase().trim() :''
	let inWishlist = false;

	onMount(()=> {
		const wishlistArr = localStorage.getItem("wishlistProducts");
		if (wishlistArr && wishlistArr.includes(productCode)) {
			toggleImage('inWishlist');
			//document.querySelector(".pdp-wishlist") ? document.querySelector(".pdp-wishlist").disabled = true : ''
		}
		// if (window.location.hash == '#addWishlist') {
		// 	if (!wishlistArr || !wishlistArr.includes(productCode)) {
		// 		wishlistHandler();
		// 	}
		// }
		//wishlistHandler(wishlistArr);
		checkIncognitoFlags();
		checkItemPriceForLoyalty();
	})

	// Scene loyalty functions
    async function isUserLoyaltyEnabled() {			
		let userData = getCookie('user')
		if (!userData) userLoyaltyEnabled = false;
		userData = JSON.parse(userData)
		if (userData.accountId == undefined) {
			userLoyaltyEnabled = false;
		} else {
			//get sceneEnabled attribute value
			let response = await fetch(`/_data/${lang}/${userData.accountId}/loyaltyEnabled`)
			let res = await response.json();
			userLoyaltyEnabled = res;
		}
	}
	
	// Check if sale Price is present for an item. If Present store it in a variable to check for loyalty marketing.
	const checkItemPriceForLoyalty = () => {
		if (price?.salePrice) {
			itemPriceForLoyalty = price?.salePrice;
		} else {
			itemPriceForLoyalty = price?.price;
		}
	}
    // Check the incognito flags and show loyalty features to end user. Implemented for incognito testing.
	const checkIncognitoFlags = () => {
		if (useLoyaltyService == "true" && displayLoyaltyToEndUser == "true") {
			showLoyaltyService = true;
		} else if (useLoyaltyService =="true" && displayLoyaltyToEndUser == "false") {
			var url = window.location.search;
			const urlParams = new URLSearchParams(url);
			const showLoyalty = urlParams.get('showLoyalty');
			if (showLoyalty == "true") showLoyaltyService = true;
		}
	}
	async function getStoreSceneAttributeValue() {
		storeSceneEnabled = window.preferredStore?.attributes?.['store-scene-enabled'] == true
	}


	// Cart increment/decrement
	function decrement(e) {
		quantity.update(n => parseInt(n || 0) - 1);
	}
	function increment(e) {
		quantity.update(n => parseInt(n || 0) + 1);
	}

	function qtyFocusOutEvt(e) {
		if (typeof $quantity !== 'number' || $quantity <= 1) {
			$quantity = Number($quantity) && Number($quantity) >= 1 ? Math.abs(Number($quantity)) : 1 || 1
		}
	}
	function qtyKeyPressEvt(event) {
		if (event.which === 13) return event.target.blur();
		return (event.which != 8 && event.which == 0 || (event.which == 46 || (event.which >= 48 && event.which <= 57)));
	}


	// Wishlist functions
	function toggleImage(forceState) {
		let blackHeart = "https://homehardware.sirv.com/hh/icons/icon-heart.blackoutline.svg";
		let redHeart = "https://homehardware.sirv.com/hh/icons/icon-heart.red.svg";
		let loaderHeart = "https://homehardware.sirv.com/hh/svg/hh-loader-circle.black.svg";
		const imgElement = document.getElementById('btn-wishlist');
		if (!imgElement) return;

		if (forceState === 'loading') {
			imgElement.src = loaderHeart;
			return;
		}

		imgElement.src = forceState == 'inWishlist' ? redHeart : blackHeart ;
		
	}
	function wishlistHandler(wishlistArr) {
		let userData = getCookie('user');
		let wishlistProducts = JSON.parse(localStorage.wishlistProducts || '[]') || []
		if (!userData) return false;
		userData = JSON.parse(userData);
		if (userData.isAnonymous === 'true' || userData.isAnonymous === true) {
			openWishlistModal = true;
			return 0;
		}
		
		toggleImage('loading')
		if(wishlistProducts?.includes(productCode)){
			const event = new CustomEvent('wishlistItemRemove', {
				detail: {
					lang: lang,
					wishlistItemId: '',
					productCode: productCode
				}
			});
			window.dispatchEvent(event);
		} else {
			const event = new CustomEvent('wishlistadded', {
				detail: {
					accountId: userData.accountId,
					lang: lang,
					productData: {
						productCode: productCode,
						quantity: 1
					}
				}
			})
			window.dispatchEvent(event);
		}

		productCategory = typeof productCategory === "string" ? JSON.parse(productCategory) : productCategory;

		let productPrice = ''
		const shouldHidePrice = price?.isHidden || availability?.codes?.some(code => ['FULL_ASSORTMENT']?.includes(code));

		if (shouldHidePrice) {
			productPrice = '';
		} else if (price?.price != '999999'){
			productPrice = price?.salePrice || price?.price;
		}

		window.dataLayer.push({
			event: wishlistProducts?.includes(productCode)? "remove_from_wishlist" :"add_to_wishlist",
			searchEngine : localStorage.getItem('ab_search') || '',
			ecommerce: {
				currencyCode: "CAD",
				add: {
					products: [
						{
							name: productName,
							id: productCode,
							price: productPrice,
							brand: productBrand,
							category: productCategoryCrumbs ? productCategoryCrumbs :productCategory?.content?.name,
							quantity: 1,
						},
					],
				},
			},
		});

		//this.disabled = true
	}

	window.addEventListener('refreshWishlistCount', () => {
		const wishlistArr = JSON.parse(localStorage?.getItem('wishlistProducts') || '[]') || [];
		const inWishlistNow = wishlistArr?.includes(productCode);
		toggleImage(inWishlistNow ? 'inWishlist' : 'notInWishlist');
		inWishlist = inWishlistNow;
	});
	

	function modalToggle() {
		openWishlistModal = !openWishlistModal
	}

	function returnUrlHandler() {
		if (window.location.search.toLowerCase().includes('returnurl')) {
			let queryString = window.location.search.toLowerCase();
			let params = new URLSearchParams(queryString)
			return params.get('returnurl') + '#addWishlist';
		}
		return window.location.href;
	}

    isUserLoyaltyEnabled();
	getStoreSceneAttributeValue();

	document.querySelector('hh-modal')?.addEventListener('mouseup', (e) => {
		const container = document.querySelector('hh-modal > div');
		if (container && !container.contains(e.target)) openWishlistModal = false;
	})

	window.addEventListener('focusOutEvt', qtyFocusOutEvt, false);

	// responsible for displaying the product fine prints (terms and conditions)
	$: sceneTnc =  buyability && storeSceneEnabled && showLoyaltyService && !(loyaltyEligible || loyaltyEligible == (lang === "fr" ? 'Exempte du programme fidelite' : 'Loyalty Earn Exemption'));
	$: selectPayTnc =  availability?.buyable && (price?.salePrice || price?.price) >= 250 && (preferredStoreProvince != 'qc');

	// new add to cart product info
	$: productInfo = [{
		productCode: productCode,
		quantity: $quantity,
		method: $method,
		ehf: ehf
	}]
	$: productInfoJSON = JSON.stringify(productInfo)

	$: if(maxQty >= 999) {
		maxQty = 999
	}
	$: if($quantity >= maxQty) {
		$quantity = maxQty
	}
	$: if(llQty && ($quantity >= llQty)) {
		$quantity = llQty
	}
</script>



{#if buyability}
    <form action="#" class="Form AddToCart" on:submit|preventDefault>
        <label for="quantity">{_strings.qty}:&nbsp</label>		
        <fieldset class="FormFlex">
            <fieldset class="Quantity">
                <button class="decrementButton" aria-label="{_strings.decrementAriaLabel}" on:click|preventDefault={decrement} disabled={$quantity === 1 ? true : false}>-</button>
                <input aria-label="{_strings.quantityAriaLabel}" size="3" id="quantity" type="text" pattern="\d*" bind:value="{$quantity}" min="1" max="999" maxlength="3" on:focusout={qtyFocusOutEvt} on:keydown="{qtyKeyPressEvt}" autocomplete="off"/>
                <button class:hideElement="{($quantity === maxQty) || ($quantity === llQty)}" aria-label="{_strings.incrementAriaLabel}" on:click|preventDefault={increment} disabled={$quantity === maxQty ? true : false }>+</button>
            </fieldset>
            <fieldset class="MobileGrow" style="flex-grow:1">
				<hh-add-button productInfo={productInfoJSON}></hh-add-button>
            </fieldset>
            <fieldset>
                <button class="pdp-wishlist" on:click={wishlistHandler}>
                    <img id="btn-wishlist" alt="icon heart" src="https://homehardware.sirv.com/hh/icons/icon-heart.blackoutline.svg">
                </button>
            </fieldset>
        </fieldset>
        {#if $quantity === llQty}
			<span class="addToCartMessage" data-color="green">{@html `<strong>${_strings.llLimitMessage} ${llQty} </strong> ${_strings.perOrder}` }</span>
        {/if}
        {#if $quantity === maxQty && (maxQty > 999 || maxQty < 999)}
            <span class="addToCartMessage" data-color="red">{_strings.maxQtyMessage}</span>
		{/if}
		{#if $quantity === maxQty && maxQty == 999}
			<span class="addToCartMessage" data-color="red">{_strings.maxPerOrder}</span>
        {/if}
        <button type="submit" style="display:none"></button>
    </form>

{:else}
	<button class="wishlistOnly" on:click = {wishlistHandler}>
		<img id="btn-wishlist" alt="icon heart" src="https://homehardware.sirv.com/hh/icons/icon-heart.blackoutline.svg">
	</button>
{/if}

{#if buyability && storeSceneEnabled && showLoyaltyService && !(loyaltyEligible || loyaltyEligible == (lang === "fr" ? 'Exempte du programme fidelite' : 'Loyalty Earn Exemption'))}
<section class="SceneBuyabilityContainer">
	{#if isProBrand}
		<section>
			<figure>
				<div class="Credit">
					<img src="https://homehardware.sirv.com/hh/Loyalty/Scene_Plus_Horizontal_ENG-Sqr.png" alt="Scene Card" />
				</div>
			</figure>
			<aside>
				<small>{@html _strings.creditCopy2}</small><br>
				<small>{_strings.conditionsApply} <a href="https://www.homehardware.ca/{lang}/landing/scotiabank-scene-visa" target="_blank" rel="nofollow" class="Underline">{_strings.learnMore}</a>**</small>
			</aside>
		</section>
		<section>
			<figure>
				<div class="ProBrand">
					<img src="https://homehardware.sirv.com/hh/Loyalty/SCOTIA_PRO_VISA_Sqr.png" alt="Scene Card" />
				</div>
			</figure>
			<aside>
				<small>{@html _strings.proBrandCopy}</small><br>
				<small>{_strings.conditionsApply} <a href="https://www.homehardware.ca/{lang}/landing/pro-visa-business-card" target="_blank" rel="nofollow" class="Underline">{_strings.learnMore}</a>**</small>
			</aside>
		</section>
	{:else}
		<section>
			<figure>
				<div class="Earn">
					<img src="https://homehardware.sirv.com/hh/Loyalty/Scene_Plus_Vertical_ENG-Sqr.png" alt="Scene Card" />
				</div>
			</figure>
			<aside>
				{#if (price?.salePrice || price?.price) < 50}
					<small><strong>{@html _strings.loyaltyCopyPDP1}</strong></small><br>
				{:else if (price?.salePrice || price?.price) < 250}
					<small><strong>{@html _strings.loyaltyCopyPDP2}</strong></small><br>
				{:else}
					<small><strong>{lang == 'en' ? 'Earn' : 'Accumulez'} {Math.floor((price?.salePrice || price?.price) / 50) * 50}</strong> {@html _strings.loyaltyCopyPDP3}</small><br>
				{/if}
				<small>{_strings.conditionsApply} <a href="https://www.homehardware.ca/{lang}/landing/sceneplus" target="_blank" rel="nofollow" class="Underline">{_strings.learnMore}</a>*</small>
			</aside>
		</section>
		<section>
			<figure>
				<div class="Credit">
					<img src="https://homehardware.sirv.com/hh/Loyalty/Scene_Plus_Horizontal_ENG-Sqr.png" alt="Scene Card" />
				</div>
			</figure>
			<aside>
				<small>{@html _strings.creditCopy1}</small><br>
				<small>{_strings.conditionsApply} <a href="https://www.homehardware.ca/{lang}/landing/scotiabank-scene-visa" target="_blank" rel="nofollow" class="Underline">{_strings.learnMore}</a>**</small>
			</aside>
		</section>
	{/if}
</section>
{/if}

<!-- Wishlist modal for users not signed in -->
{#if openWishlistModal}
	<Portal target="hh-modal" >
			<h3 class="Center modalHeading">	<img id="btn-wishlist" alt="icon heart" src="https://homehardware.sirv.com/hh/icons/icon-heart.blackoutline.svg">{_strings.myList}</h3>
			<p class="Center">{_strings.listContent}</p>
			<div class="buttonGroup">
				<a class="Button" href={`/${lang}/user/login?returnurl=${returnUrlHandler()}#addWishlist`}>{_strings.logIn}</a>
				<button class="Button ButtonSecondary" on:click="{modalToggle}">{_strings.noThanks}</button>
			</div>
	</Portal>
{/if}


<!-- product fine print (terms and conditions) paragraph accordion-->
{#if sceneTnc  === true|| isMadeInCanada != "false" || isProductOfCanada != "false" || selectPayTnc === true}
	<Portal target="#finePrintBigHelp">
		<details>
			<summary class="h2">{_strings.fineprintBigHelp}</summary>
				{#if selectPayTnc}
					<p> {_strings.scotiaSelectPayConditions}</p>
				{/if}
				{#if sceneTnc === true}
					<p>{!isProBrand ? _strings.conditions1 : ''}</p>
					<p>{_strings.conditions2}</p>
				{/if}
				{#if isMadeInCanada != "false" || isProductOfCanada != "false"}
					<p> {_strings.canadaBannerConditions}</p>
				{/if}
		</details>
	</Portal>
{/if}

<style>
    button.addToCartBtn:disabled {
        opacity: 0.5 !important;
    }
	.animate {
		animation: yyz .5s ease;
	}

	@keyframes yyz {
		from {
			opacity: 0;
			transform: translateY(1rem);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	:global(.hideElement){
		visibility: hidden;
	}

	form.Form.AddToCart{
		display: grid;
		grid-template-columns: 1fr 13fr;
		align-items: baseline;		
	}
	.FormFlex {
		justify-content: space-between;
		align-items: center;
		flex-wrap: nowrap;
	}
	.Quantity button {
		font-size: 1.5rem;
		transform: scale(1.25);
		color: var(--hh-black);
	}

	.pdp-wishlist{
		border: 2px solid #000000;
		border-radius: 50%;
		padding: 10px 12px;
		appearance: none;
		outline: none;
		display: inline-block;
		line-height: 120%;
		margin: 0; 
		background-color: var(--hh-white);
	}
	
	.wishlistOnly{
		border: 2px solid #000000;
		border-radius: 50%;
		padding: 6px 8px;
		appearance: none;
		outline: none;
		display: inline-block;
		line-height: 120%;
		margin: 0;
		background-color: #F7F7F7;
		position: absolute;
		top: 25px;
		right: 30px;
	}
	img#btn-wishlist {
		margin-top: 2px;
		width: 20px;
		height: 17.53px;
		cursor: pointer;
	}
	.addToCartMessage{
		display: block;
		grid-column: 1/span 2;
		line-height: 2;
	}
	.addToCartMessage[data-color="red"] {
		color: var(--hh-red);
	}
	.addToCartMessage[data-color="green"] {
		color: #4A4A4A;
	}
	.modalHeading {
		border-bottom: 1px solid var(--hh-grey);
		padding-bottom: 0.8em;
	}
	.modalHeading > img:first-child {
		margin-right: 8px;
	}
	.buttonGroup {
		margin-top: 1em;
	}
	.buttonGroup a {
		text-decoration: none;
	}

	@media (max-width: 600px) {
		.wishlistOnly{
			top: 8px;
			right: 12px;
		}
		.Form.AddToCart > label {
			display: none;
		}
		form.Form.AddToCart{
			display: block;
			z-index: 2;
			box-shadow: 0 0 12px rgba(0,0,0,.0801464);
		}
	}
	@media (max-width: 800px) {
		.AddToCart {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			background: var(--hh-white);
			padding: var(--gap) var(--gap) 0;
			z-index: 2;
		}
		form.Form.AddToCart{
			display: block;
		}
		.Form.AddToCart > label {
			display: none;
		}
	}
	@media(min-width:800px) and (max-width: 1024px){ 
		.AddToCart .Quantity input {
			width: 50px;
		}
		.Form.AddToCart > label {
			display: none;
		}
		form.Form.AddToCart{
			display: block;
		}
	}


	/* NEW LOYALTY GRID LAYOUT */
	.loyalty-marketing {
		display: grid;
		grid-template-columns: 1fr 3fr;
		box-shadow: 0 0 0 1px #0003 inset;
		border-radius: calc(var(--gap) / 4);
		overflow: hidden;
	}
	img#scene {
		align-self: center;
		justify-self: center;
		margin-bottom: 4px;
		padding: calc(var(--gap) / 2);
		max-width: 70%;
		min-width: 75px;
	}
	.loyalty-marketing p {
		font-family: 'hhAgendaBold';
		line-height: 1.2;
		background: var(--hh-black);
		color: var(--hh-white);
		padding: calc(var(--gap) / 3) var(--gap);
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.SceneBuyabilityContainer {
		display: grid;
		grid-template-columns: 1fr;
		grid-gap: 1em;
		border-radius: 6px;
		overflow: hidden;
		margin-bottom: 2rem;
		line-height: 1.3;
	}
	.SceneBuyabilityContainer > section {
		display: flex;
		flex-direction: row;
		border-radius: 6px;
		overflow: hidden;
		background: url('https://homehardware.sirv.com/hh/icons/Icon_SceneDots.svg') no-repeat 101% -3%, var(--hh-light-grey);
		background-size: 9%;
		box-shadow: 0 0 0 1px #0001 inset, 0 1rem 2rem -1rem #eeeeee;
	}
	.SceneBuyabilityContainer > section > figure {
		background: black;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-block: calc(var(--gap) / 4);
		margin: 0;
	}
	.SceneBuyabilityContainer > section > figure > div {
		padding: 0.75em;
		margin: 0 -2.5em 0 -0.5em;
		border-radius: 50%;	
		aspect-ratio: 1/1;
	}
	.SceneBuyabilityContainer > section > figure > div.Earn {
		background: #903BFF;
	}
	.SceneBuyabilityContainer > section > figure > div.Credit {
		background: #FF343F;
	}
	.SceneBuyabilityContainer > section > figure > div.ProBrand {
		background: #D8D6CA;
	}
	.SceneBuyabilityContainer > section > figure > div img {
		max-height: 3.5em;
		display: flex;
	}
	.SceneBuyabilityContainer > section > aside {
		padding: 1em 3.25em;
		align-content: center;
	}
	:global(.Trademark) {
		font-size: 0.4rem;
	}
</style>